import { render, staticRenderFns } from "./PriceModal.vue?vue&type=template&id=14dedfb2&scoped=true&"
import script from "./PriceModal.vue?vue&type=script&lang=js&"
export * from "./PriceModal.vue?vue&type=script&lang=js&"
import style0 from "./PriceModal.vue?vue&type=style&index=0&id=14dedfb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dedfb2",
  null
  
)

export default component.exports